<template>
    <div class="content">
        <NotFoundy />
    </div>
</template>

<script setup>
    import NotFoundy from '@/components/NotFound.vue'
    document.title = 'Halaman Tidak Ditemukan - Food Traveller Bandung';
</script>